// AI Generated Component
import { Component, OnInit, Input } from '@angular/core';
import { GlobalAccessibilityChecksRepoService } from '@client/app/services/accessibility-checks-repo/GlobalAccessibilityChecksRepo.service';
import { SourceCodeExcludesService } from '../../../../services/source-code-excludes.service';

interface AccessibilityCheck {
    id: number;
    name: string;
}

interface FormModel {
    module?: string;
    [key: string]: any;
}

@Component({
    selector: 'form-source-code-exclude-steps-form',
    standalone: false,
    template: `
        <div class="mt-3 mx-3">
            <form-source-code-exclude-accessibility
                    *ngIf="accessibilityChecksLoading !== null && isAccessibility(model.module)"
                    [model]="model"
                    [accessibilityChecksLoading]="accessibilityChecksLoading">
            </form-source-code-exclude-accessibility>
            <form-source-code-exclude-sce
                    *ngIf="!isAccessibility(model.module)"
                    [model]="model"
                    [modelGroup]="modelGroup">
            </form-source-code-exclude-sce>
        </div>
    `,
})
export class FormSourceCodeExcludeStepsFormComponent implements OnInit {
    @Input() modelGroup = '';
    @Input() model;
    ngModel: FormModel = {};
    accessibilityChecksLoading: Promise<AccessibilityCheck[]> | null = null;

    constructor (
        private globalAccessibilityChecksRepoService: GlobalAccessibilityChecksRepoService,
        private sourceCodeExcludesService: SourceCodeExcludesService,
    ) {}

    ngOnInit (): void {
        this.setupDefaultAccessibilityChecksOptions();
    }

    isAccessibility (module: string): boolean {
        return this.sourceCodeExcludesService.isAccessibility(module as any);
    }

    private setupDefaultAccessibilityChecksOptions (): void {
        this.accessibilityChecksLoading = this.globalAccessibilityChecksRepoService.getAll({ page_size: 0 }).then(
            (checks: AccessibilityCheck[]) => {
                return checks.sort((a, b) => a.name.localeCompare(b.name));
            },
            () => {
                return [];
            },
        );
    }
}
